// extracted by mini-css-extract-plugin
module.exports = {"main_content":"Files_main_content__28j_I"};